import React from "react";
import { UncontrolledTooltip } from "reactstrap";

/**
 *
 * @User : 이연우
 * @Date : 2023.06.29
 * @file : Components/Common/CpmCommTooltip.js
 * @Desc : 툴팁 컴포넌트
 * @param {string} id - id값
 * @param {string} disc - 내용물
 */

const CpmCommTooltip = ({id, disc}) => {
    return (
        <>
            <i
                className="las la-question-circle cs-p fs-4 text-muted ms-2"
                id={`tooltip-${id}`}
            />
            <UncontrolledTooltip
                placement="right"
                target={`tooltip-${id}`}
                className='text-wrap'
                style={{textAlign: 'start', wordBreak: 'keep-all'}}
                transition = {{ timeout:150 }}
            >
                {disc}
            </UncontrolledTooltip>
        </>
    );
};

export default CpmCommTooltip;
